import React, { useState, useEffect } from "react";
import LogoJibuness from "../../images/logo-jibuness.png";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Form,  Spinner, Alert } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");

  const onFormSubmit = async (formData) => {
    setLoading(true);
    setError("");
    
    try {
      const { api, setAuthToken } = await import("../../utils/api");
      const response = await api.login(formData.email, formData.password);
      
      if (response.token) {
        setAuthToken(response.token);
        localStorage.setItem("user", JSON.stringify(response.user));
        setTimeout(() => {
          window.history.pushState(
            `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}`,
            "auth-login",
            `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}`
          );
          window.location.reload();
        }, 500);
      }
    } catch (err) {
      setError(err.message || "Impossible de se connecter avec ces identifiants");
      setLoading(false);
    }
  };

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    const authBg = '#345C74';

    htmlElement.style.setProperty('background-color', authBg, 'important');
    htmlElement.style.minHeight = '100vh';

    bodyElement.style.setProperty('background-color', authBg, 'important');
    bodyElement.style.minHeight = '100vh';

    return () => {
      htmlElement.style.removeProperty('background-color');
      htmlElement.style.minHeight = '';

      bodyElement.style.removeProperty('background-color');
      bodyElement.style.minHeight = '';
    };
  }, []);

  return (
    <React.Fragment>
      <Head title="Login" />
      <div 
        style={{
          minHeight: '100vh',
          position: 'relative',
          width: '100%',
        }}
      >
        <PageContainer transparent={true}>
          <Block className="nk-block-middle nk-auth-body  wide-xs">
            <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
              <div className="brand-logo text-center pb-4 mb-0">
                <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link">
                  <img
                    className="logo-img logo-img-lg"
                    src={LogoJibuness}
                    alt="Jibuness"
                    style={{
                      width: "min(85vw, 160px)",
                      maxWidth: "100%",
                      maxHeight: "min(28vh, 100px)",
                      height: "auto",
                      objectFit: "contain",
                    }}
                  />
                </Link>
              </div>
              <BlockHead>
                <BlockContent className="text-center">
                  <BlockTitle tag="h4" className="text-center">Connexion</BlockTitle>
                  <BlockDes className="text-center">
                    <p>Connectez-vous à votre compte HSE</p>
                  </BlockDes>
                </BlockContent>
              </BlockHead>
            {errorVal && (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {errorVal}
                </Alert>
              </div>
            )}
            <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Email
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="email"
                    id="default-01"
                    name="email"
                    ref={register({ 
                      required: "Ce champ est requis",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Email invalide"
                      }
                    })}
                    placeholder="Entrez votre adresse email"
                    className="form-control-lg form-control"
                  />
                  {errors.email && <span className="invalid">{errors.email.message}</span>}
                </div>
              </div>
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="password">
                    Mot de passe
                  </label>
                  <Link className="link link-primary link-sm" to={`${process.env.PUBLIC_URL}/auth-reset`}>
                    Mot de passe oublié ?
                  </Link>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>
                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="password"
                    name="password"
                    ref={register({ required: "Ce champ est requis" })}
                    placeholder="Entrez votre mot de passe"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                  />
                  {errors.password && <span className="invalid">{errors.password.message}</span>}
                </div>
              </div>
              <div className="form-group">
                <Button size="lg" className="btn-block" type="submit" color="primary" disabled={loading}>
                  {loading ? <Spinner size="sm" color="light" className="me-2" /> : null}
                  {loading ? "Connexion..." : "Se connecter"}
                </Button>
              </div>
            </Form>
          </PreviewCard>
        </Block>
        <AuthFooter />
      </PageContainer>
      </div>
    </React.Fragment>
  );
};
export default Login;
